import { connect } from 'react-redux';

import SideMenuBarScreen from './SideMenuBarScreen';
import { iRootDispatch, iRootState } from '../../../store/store';
import SideMenuBarScreenDispatchProps from './SideMenuBarScreenDispatchProps';

const mapStateToProps = (state: iRootState) => ({
    expand: state.Settings.expandMenu,
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: any) =>
    ({
        expandMenu: _dispatch.Settings.expand,
        ..._ownDispatch,
    } as SideMenuBarScreenDispatchProps);

export const SideMenuBarScreenContainer = connect(
    mapStateToProps,
    mapDispatch as any
)(SideMenuBarScreen);
